import { render, staticRenderFns } from "./NavSearchResultsItem.vue?vue&type=template&id=5bd4d55f"
import script from "./NavSearchResultsItem.vue?vue&type=script&lang=js"
export * from "./NavSearchResultsItem.vue?vue&type=script&lang=js"
import style0 from "./NavSearchResultsItem.vue?vue&type=style&index=0&id=5bd4d55f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports